export const supportedLngs = ["en", "ja"] as const;
export type AppLocale = (typeof supportedLngs)[number];

const defaultNS = "common";

const namespaces = [
  "common",
  "nav",
  "errors",
  "footer",
  "docs",
  "marketing",
  "auth",
  "settings",
  "validation",
  "integrations",
  "chat",
  "schedule",
  "workbench",
  "operators",
  "community",
  "listings",
  "dashboard",
  "billing",
  "webhooks",
] as const;

export default {
  supportedLngs: [...supportedLngs],
  fallbackLng: "en",
  defaultNS,
  ns: [...namespaces],
  interpolation: { escapeValue: false },
};
